import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createAccountTenant, promoteAccount } from '@/api/promote';
import type { PromoteAccountRequest } from '@/types/promote';

export function usePromoteAccount(accountId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: PromoteAccountRequest) => promoteAccount(accountId, body),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['crm', 'account', accountId] }),
        queryClient.invalidateQueries({ queryKey: ['crm', 'accounts'] }),
        queryClient.invalidateQueries({ queryKey: ['crm', 'dashboard'] }),
      ]);
    },
  });
}

export function useCreateAccountTenant(accountId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: PromoteAccountRequest) => createAccountTenant(accountId, body),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['crm', 'account', accountId] }),
        queryClient.invalidateQueries({ queryKey: ['crm', 'account', accountId, 'tenants'] }),
        queryClient.invalidateQueries({ queryKey: ['crm', 'accounts'] }),
        queryClient.invalidateQueries({ queryKey: ['crm', 'dashboard'] }),
      ]);
    },
  });
}
